@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

.error-wrapper {
  width: 100%;
  margin: 0 auto;
  padding: 1em 0 0.5em 0;
}

.error-message {
  text-align: center;
  color: colors.$header;
}
